import React, { useEffect, useState, useLayoutEffect } from "react";

const StateContext = React.createContext();
const DispatchContext = React.createContext();

const EnviroMetricMapContextProvider = ({
  children,
  controlState,
  setAnimationEnabled,
  setBackgroundIndex,
  setAdditionalLayers,
  setSelectedSimulation,
  setDisplayMode,
  setValueMode,
  setCurrentFeatureInfoValue,
  setCurrentFeatureInfoPosition,
  setFeatureInfoModeActivation,
  setCurrentFeatureInfoSelectedSimulation,
  setCurrentFeatureInfoSelectedDisplayMode,
  setCurrentFeatureInfoSelectedValueMode,
}) => {
  return (
    <StateContext.Provider value={{ controlState }}>
      <DispatchContext.Provider
        value={{
          setAnimationEnabled,
          setBackgroundIndex,
          setAdditionalLayers,
          setSelectedSimulation,
          setDisplayMode,
          setValueMode,
          setCurrentFeatureInfoValue,
          setCurrentFeatureInfoPosition,
          setFeatureInfoModeActivation,
          setCurrentFeatureInfoSelectedSimulation,
          setCurrentFeatureInfoSelectedDisplayMode,
          setCurrentFeatureInfoSelectedValueMode,
        }}
      >
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};

export default EnviroMetricMapContextProvider;
export {
  EnviroMetricMapContextProvider,
  StateContext as EnviroMetricMapContext,
  DispatchContext as EnviroMetricMapDispatchContext,
};
